import { Component } from 'vue-property-decorator';
import Base from '@/components/Base';
import TopNav from '@/components/topnav/TopNav.vue';
import VideoPlayerModal from '@/components/editor/modals/VideoPlayerModal.vue';
import { EModalName } from '@/helpers/modal';

interface ITutorialVideos {
  title: string;
  url: string;
  duration?: number;
}

@Component({
  components: {
    TopNav,
    VideoPlayerModal,
  },
})
export default class TutorialPage extends Base {
  async mounted() {
  }

  get tutorialVideos(): ITutorialVideos[] {
    return [
      {
        title: 'How to Get Started',
        url: 'https://www.youtube.com/embed/RcDSOznrcks',
      },
      {
        title: 'General Layout Tutorial',
        url: 'https://www.youtube.com/embed/x1hNa1z6bgw',
      },
      {
        title: 'How to Use Overlays',
        url: 'https://www.youtube.com/embed/er05wugNW30',
      },
      {
        title: 'How to Add Alerts, Text and other Components',
        url: 'https://www.youtube.com/embed/xnbKu8w0cgY',
      },
      {
        title: 'How to Add Scenes and Transitions',
        url: 'https://www.youtube.com/embed/1sLqdbi1UcQ',
      },
    ];
  }

  openVideoPlayer(video) {
    this.$modal.show(EModalName.videoPlayer, { videoUrl: video.url });
  }

  formatDuration(duration: number) {
    const minutes = Math.floor(duration / 60);
    const seconds = duration % 60;

    return `${minutes}:${seconds}`;
  }
}
